import React from 'react'
import styled from "styled-components"
import Babatunde from './Images/Babatunde.jpg'
import Derrick from './Images/Derrick.jpeg'
import Ogo from './Images/Ogo.jpeg'
import Fola from './Images/Fola.jpeg'
import Maduka from './Images/Maduka.jpeg'
import Valentino from './Images/Valentino.jpeg'
import Emma from './Images/Emma.jpeg'
import Lael from './Images/Lael.jpeg'
import Tarzan from './Images/Tarzan.jpeg'
import Folarin from './Images/Folarin.jpeg'
import Timi from './Images/Samuel Timi.jpg'
import Ezekiel from './Images/Michael Ezekiel.jpeg'


function Buckets() {
    return (
        <div>
            <h1>BUCKETS</h1>
            <h3>OWNER: Bayo Atkinson</h3>
            <br/>
            <Div>
                <div><Img src={Derrick}/> Ifeme Derrick</div><br/>
                <div><Img src={Ogo}/> Ogochukwu Ikatule </div><br/>
                <div><Img src={Babatunde}/> Ogungbamila Babatunde</div><br/>
                <div><Img src={Fola}/> Fola shoegod</div><br/>
                <div><Img src={Maduka}/> Maduka</div><br/>
                <div><Img src={Emma}/> Emmanuel Sunday</div><br/>
                <div><Img src={Folarin}/> Oyegbade Folarin</div><br/>
                <div><Img src={Valentino}/> Ogbechie Valentino</div><br/>
                <div><Img src={Lael}/> Lael Butler</div><br/>
                <div><Img src={Tarzan}/> Adejare Ajibola</div><br/>
                <div><Img src={Timi}/> Samuel Timi</div><br/>
                <div><Img src={Ezekiel}/> Michael Ezekiel</div><br/>
                <div><Img src=""/> Joba Oparinde</div>
            </Div>
    
            
        </div>
      )
}

export default Buckets

const Img = styled.img`
height: 300px;
width: 300px;
@media screen and (max-width: 750px) {
  height: 150px;
  width: 150px;
}
`

const Div = styled.div`
font-size: 20px;
font-weight: bold;
`